import classes from "./FlatStatCard.module.css";

interface Props {
  title: string;
  /** Literal hex — the card is a solid brand-accent block. */
  color: string;
  items: { value: string; label: string }[];
}

/**
 * Solid accent card showing two headline numbers.
 *
 * Reads the same CALORIC_BALANCE.SECTION2 fields as the shared CalsTable but not
 * its markup: that renders one row split by 5px side borders rather than two flat
 * blocks.
 */
const FlatStatCard = ({ title, color, items }: Props): JSX.Element => (
  <div className={classes.card} style={{ backgroundColor: color }}>
    <div className={classes.title}>{title}</div>
    <div className={classes.values}>
      {items.map((item) => (
        <div className={classes.item} key={item.label}>
          <div className={classes.value}>{item.value}</div>
          <div className={classes.label}>{item.label}</div>
        </div>
      ))}
    </div>
  </div>
);

export default FlatStatCard;
